import axios from 'axios';

export const getCurrentLegalDocument = () => {
    return axios.get('/api/legal-document/current');
};

export const saveUserLegalDocumentSignedOn = (source = 'web') => {
  return axios.post('/api/legal-document/user', { source });
};
